export default function CGU() {
  return (
    <div className="container mb-5 px-3 px-md-4" style={{ maxWidth: '800px' }}>

      <h1 className="mb-2 text-center" style={{ fontSize: 'clamp(1.3rem, 5vw, 2rem)', fontWeight: 700 }}>
        Conditions Générales d'Utilisation
      </h1>
      <p className="text-center text-muted mb-4" style={{ fontSize: '0.85rem' }}>
        Version en vigueur — Dernière mise à jour : juin 2025
      </p>

      {/* ── Préambule ────────────────────────────────────────────────────── */}
      <section className="mb-4 p-3 rounded" style={{ background: '#f8f9fa', border: '1px solid #dee2e6', fontSize: '0.9rem' }}>
        <p className="mb-0">
          SpotyPark est édité par <strong>SpotyPark</strong> — projet collaboratif en phase de test.<br />
          Contact : <a href="/contact">Cliquer sur le lien</a> —{' '}
          <a href="https://www.spotypark.fr" target="_blank" rel="noopener noreferrer">www.spotypark.fr</a>
        </p>
      </section>

      {/* ── 1. Acceptation ───────────────────────────────────────────────── */}
      <section className="mb-4">
        <h2 style={{ fontSize: '1.1rem', fontWeight: 700 }}>1. Acceptation des conditions</h2>
        <p>
          En créant un compte ou en utilisant l'application SpotyPark, vous acceptez sans réserve
          les présentes CGU ainsi que notre{' '}
          <a href="/confidentialite" target="_blank" rel="noopener noreferrer">
            Politique de Confidentialité
          </a>.
          Si vous n'acceptez pas ces conditions, vous ne devez pas utiliser le service.
        </p>
        <p>
          L'accès au service est réservé aux personnes physiques majeures (18 ans ou plus) ou aux
          mineurs dûment autorisés par leurs représentants légaux.
        </p>
      </section>

      {/* ── 2. Description du service ────────────────────────────────────── */}
      <section className="mb-4">
        <h2 style={{ fontSize: '1.1rem', fontWeight: 700 }}>2. Description du service</h2>
        <p>
          SpotyPark est une plateforme collaborative permettant à ses utilisateurs de :
        </p>
        <ul>
          <li>Localiser et visualiser des places de stationnement disponibles en temps réel.</li>
          <li>Signaler la libération imminente d'une place.</li>
          <li>Proposer leur place à la cession contre rémunération (fonctionnalité réservée aux abonnés).</li>
          <li>Réserver une place auprès d'un autre utilisateur.</li>
          <li>Naviguer par GPS vers une place sélectionnée.</li>
        </ul>
        <p>
          SpotyPark agit en qualité d'<strong>intermédiaire technique</strong> entre utilisateurs
          et n'est pas partie aux transactions entre eux.
        </p>
      </section>

      {/* ── 3. Inscription et compte ─────────────────────────────────────── */}
      <section className="mb-4">
        <h2 style={{ fontSize: '1.1rem', fontWeight: 700 }}>3. Inscription et sécurité du compte</h2>
        <ul>
          <li>Vous devez fournir des informations exactes, complètes et à jour lors de votre inscription.</li>
          <li>Une adresse e-mail valide et vérifiée est requise pour accéder à l'ensemble des fonctionnalités.</li>
          <li>Vous êtes seul responsable de la confidentialité de vos identifiants et de toute activité réalisée depuis votre compte.</li>
          <li>Tout partage de compte avec un tiers est interdit.</li>
          <li>Toute suspicion de fraude ou d'utilisation non autorisée doit être signalée immédiatement sur l'application <a href="/contact">contact</a>.</li>
          <li>SpotyPark se réserve le droit de demander une vérification d'identité en cas de suspicion de fraude.</li>
        </ul>
      </section>

      {/* ── 4. Utilisation acceptable ────────────────────────────────────── */}
      <section className="mb-4">
        <h2 style={{ fontSize: '1.1rem', fontWeight: 700 }}>4. Utilisation acceptable</h2>
        <p>Vous vous engagez à :</p>
        <ul>
          <li>Utiliser SpotyPark de manière légale, loyale et conforme à l'esprit collaboratif de la plateforme.</li>
          <li>Ne signaler que des places réellement disponibles ou sur le point de l'être.</li>
          <li>Ne proposer à la cession que des places dont vous êtes l'occupant légitime au moment de la transaction.</li>
          <li>Respecter les autres utilisateurs et adopter un comportement courtois.</li>
          <li>Ne pas tenter de contourner les mécanismes de sécurité, de limitation ou de modération.</li>
          <li>Ne pas utiliser de moyens automatisés (bots, scripts) pour interagir avec le service.</li>
          <li>Ne pas usurper l'identité d'un autre utilisateur ou tiers.</li>
        </ul>
        <p>
          Tout manquement à ces obligations peut entraîner la suspension ou la suppression immédiate du compte,
          sans préjudice de toute action en responsabilité civile ou pénale.
        </p>
      </section>

      {/* ── 5. Abonnements et paiements ──────────────────────────────────── */}
      <section className="mb-4">
        <h2 style={{ fontSize: '1.1rem', fontWeight: 700 }}>5. Abonnements et paiements</h2>
        <ul>
          <li>
            Certaines fonctionnalités (cession de place, accès aux demandes acheteurs) sont réservées
            aux abonnés <strong>SPOTYFLEX</strong> (mensuel) ou <strong>SPOTYZEN</strong> (annuel).
          </li>
          <li>
            Les paiements sont traités de manière sécurisée via <strong>Stripe</strong>.
            SpotyPark ne stocke jamais vos données bancaires.
          </li>
          <li>
            SpotyPark perçoit une <strong>commission de 15 %</strong> sur chaque transaction
            de cession de place réalisée via la plateforme.
          </li>
          <li>
            Les abonnements sont résiliables à tout moment depuis votre espace compte.
            La résiliation prend effet à l'échéance de la période en cours.
          </li>
          <li>
            Conformément à l'article L.221-18 du Code de la consommation, vous disposez d'un
            <strong> droit de rétractation de 14 jours</strong> à compter de la souscription,
            sauf si vous avez expressément demandé à bénéficier du service avant l'expiration
            de ce délai.
          </li>
        </ul>
      </section>

      {/* ── 6. Réservation, annulation et remboursement ──────────────────── */}
      <section className="mb-4">
        <h2 style={{ fontSize: '1.1rem', fontWeight: 700 }}>6. Réservation, annulation et remboursement</h2>
        <ul>
          <li>
            <strong>Annulation par l'acheteur :</strong>
            <ul>
              <li>Plus de 24h avant : remboursement à 100 %.</li>
              <li>Entre 12h et 24h avant : remboursement à 50 %.</li>
              <li>Moins de 12h avant : aucun remboursement.</li>
            </ul>
          </li>
          <li>
            <strong>Annulation par le vendeur :</strong> plafonnée à 5 annulations par jour.
            Au-delà, le compte vendeur peut être suspendu pour une durée de 7 jours.
          </li>
          <li>
            En cas de place indisponible à l'arrivée de l'acheteur (place déjà occupée ou inexistante),
            un remboursement intégral sera effectué sur signalement dans l'application.
          </li>
          <li>
            Les remboursements sont traités par Stripe et apparaissent sur votre moyen de paiement
            sous 5 à 10 jours ouvrés.
          </li>
        </ul>
      </section>

      {/* ── 7. Programme Pionniers ───────────────────────────────────────── */}
      <section className="mb-4">
        <h2 style={{ fontSize: '1.1rem', fontWeight: 700 }}>7. Programme Pionniers</h2>
        <p>
          SpotyPark propose un programme de pionniers limité à <strong>50 participants</strong>.
          Les pionniers bénéficient d'un accès gratuit au service pendant la phase de lancement
          et d'avantages exclusifs en échange de leur participation active et de leurs retours.
          SpotyPark se réserve le droit de modifier ou d'interrompre ce programme à tout moment.
        </p>
      </section>

      {/* ── 8. Programme de parrainage et points ─────────────────────────── */}
      <section className="mb-4">
        <h2 style={{ fontSize: '1.1rem', fontWeight: 700 }}>8. Programme de parrainage et points de fidélité</h2>
        <ul>
          <li>
            Le programme de parrainage permet à un utilisateur de parrainer de nouveaux inscrits
            et d'obtenir des récompenses définies par SpotyPark.
          </li>
          <li>
            Les points de fidélité sont attribués pour certaines actions (signalements, transactions,
            parrainage). Ils ne sont pas remboursables en espèces et ne constituent pas une monnaie.
          </li>
          <li>
            SpotyPark se réserve le droit de modifier à tout moment les règles d'attribution
            et de conversion des points.
          </li>
        </ul>
      </section>

      {/* ── 9. Propriété intellectuelle ──────────────────────────────────── */}
      <section className="mb-4">
        <h2 style={{ fontSize: '1.1rem', fontWeight: 700 }}>9. Propriété intellectuelle</h2>
        <p>
          L'ensemble des éléments constituant SpotyPark (marque, logo, design, code source,
          contenus éditoriaux, base de données) est la propriété exclusive de SpotyPark
          et est protégé par le droit de la propriété intellectuelle.
          Toute reproduction, représentation, modification ou exploitation, totale ou partielle,
          sans autorisation écrite préalable est strictement interdite.
        </p>
        <p>
          En publiant du contenu sur la plateforme (signalements, avis, photos),
          vous accordez à SpotyPark une licence non exclusive, mondiale et gratuite
          d'utilisation de ce contenu aux fins du service.
        </p>
      </section>

      {/* ── 10. Limitation de responsabilité ─────────────────────────────── */}
      <section className="mb-4">
        <h2 style={{ fontSize: '1.1rem', fontWeight: 700 }}>10. Limitation de responsabilité</h2>
        <ul>
          <li>
            SpotyPark agit comme intermédiaire et ne garantit pas la disponibilité effective
            des places signalées ni l'exactitude des informations publiées par les utilisateurs.
          </li>
          <li>
            L'application est fournie "en l'état", sans garantie d'accessibilité permanente,
            d'absence d'erreur ou d'interruption.
          </li>
          <li>
            SpotyPark ne peut être tenu responsable des dommages directs ou indirects résultant
            de l'utilisation ou de l'impossibilité d'utiliser le service.
          </li>
          <li>
            SpotyPark n'est pas responsable des litiges survenus entre utilisateurs
            (inexactitude d'annonce, absence du vendeur, dommages au véhicule, etc.).
          </li>
          <li>
            La responsabilité de SpotyPark est en tout état de cause limitée au montant
            de la transaction concernée.
          </li>
        </ul>
      </section>

      {/* ── 11. Modération et sanctions ──────────────────────────────────── */}
      <section className="mb-4">
        <h2 style={{ fontSize: '1.1rem', fontWeight: 700 }}>11. Modération et sanctions</h2>
        <p>
          Tout utilisateur s'engage à respecter la{' '}
          <a href="/charte-moderation">charte de modération</a> de SpotyPark.
          En cas de manquement, SpotyPark peut appliquer les mesures suivantes :
        </p>
        <ul>
          <li>Avertissement par e-mail.</li>
          <li>Suspension temporaire du compte (de 7 à 30 jours selon la gravité).</li>
          <li>Suppression définitive du compte sans remboursement de l'abonnement en cours.</li>
          <li>Signalement aux autorités compétentes en cas d'infraction pénale.</li>
        </ul>
        <p>
          Toute décision de suspension peut être contestée en contactant notre support via{' '}
          <a href="/contact">Nous contacter</a> dans un délai
          de 30 jours suivant la notification.
        </p>
      </section>

      {/* ── 12. Résiliation ──────────────────────────────────────────────── */}
      <section className="mb-4">
        <h2 style={{ fontSize: '1.1rem', fontWeight: 700 }}>12. Résiliation</h2>
        <ul>
          <li>
            Vous pouvez supprimer votre compte à tout moment depuis les paramètres de l'application.
            La suppression entraîne l'effacement de vos données personnelles dans les délais
            prévus par notre Politique de Confidentialité.
          </li>
          <li>
            SpotyPark se réserve le droit de suspendre ou supprimer tout compte en cas d'infraction
            aux présentes CGU, sans préavis ni remboursement.
          </li>
          <li>
            En cas de suppression, les transactions en cours sont finalisées et les remboursements
            éventuels traités conformément à l'article 6.
          </li>
        </ul>
      </section>

      {/* ── 13. Évolution des conditions ─────────────────────────────────── */}
      <section className="mb-4">
        <h2 style={{ fontSize: '1.1rem', fontWeight: 700 }}>13. Évolution des conditions</h2>
        <p>
          SpotyPark peut modifier les présentes CGU à tout moment.
          Toute modification substantielle sera notifiée par e-mail ou via l'application
          <strong> au moins 30 jours avant</strong> son entrée en vigueur.
          La poursuite de l'utilisation du service après cette date vaut acceptation
          des nouvelles conditions.
        </p>
      </section>

      {/* ── 14. Loi applicable et litiges ────────────────────────────────── */}
      <section className="mb-4">
        <h2 style={{ fontSize: '1.1rem', fontWeight: 700 }}>14. Loi applicable et résolution des litiges</h2>
        <p>
          Les présentes CGU sont régies par le <strong>droit français</strong>.
          En cas de litige, une solution amiable sera recherchée en priorité.
          À défaut, vous pouvez recourir à un médiateur de la consommation
          conformément aux articles L.611-1 et suivants du Code de la consommation.
          En dernier recours, les tribunaux compétents du ressort de [Ville du siège social]
          seront seuls compétents.
        </p>
        <p>
          Conformément à l'article 14 du règlement UE n°524/2013, vous pouvez également
          recourir à la plateforme européenne de règlement en ligne des litiges :{' '}
          <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">
            https://ec.europa.eu/consumers/odr
          </a>
        </p>
      </section>

      {/* ── 15. Dispositions diverses ────────────────────────────────────── */}
      <section className="mb-4">
        <h2 style={{ fontSize: '1.1rem', fontWeight: 700 }}>15. Dispositions diverses</h2>
        <ul>
          <li>
            Si une clause des présentes conditions s'avérait nulle ou inapplicable,
            les autres dispositions resteraient pleinement en vigueur.
          </li>
          <li>
            Le fait pour SpotyPark de ne pas se prévaloir d'un manquement ne constitue
            pas une renonciation à s'en prévaloir ultérieurement.
          </li>
          <li>
            Ces CGU constituent l'intégralité de l'accord entre vous et SpotyPark
            concernant l'utilisation du service.
          </li>
        </ul>
      </section>

      {/* ── 16. Contact ──────────────────────────────────────────────────── */}
      <section>
        <h2 style={{ fontSize: '1.1rem', fontWeight: 700 }}>16. Contact</h2>
        <p>
          Pour toute question relative aux présentes CGU :<br />
          <strong>SpotyPark</strong> — <a href="/contact">cliquer sur le lien</a><br />
          <a href="https://www.spotypark.fr" target="_blank" rel="noopener noreferrer">
            www.spotypark.fr
          </a>
        </p>
      </section>

    </div>
  );
}